import axios from 'axios'
// import store from '@/store'
// import store from '@/store'
import router from '../router'
import notification from 'ant-design-vue/es/notification'
import message from 'ant-design-vue/es/message'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { Modal } from 'ant-design-vue'
import qs from 'qs'
// import cookie from 'js-cookie'

// 异常拦截处理器
const errorHandler = error => {
  if (error.response) {
    const data = error.response.data
    notification.error({
      message: 'Forbidden',
      description: data.message
    })
  }
  // if (error.response) {
  // const data = error.response.data
  // 获取 token
  // const token = cookie.get(ACCESS_TOKEN)
  // if (error.response.status === 403) {
  //   notification.error({
  //     message: 'Forbidden',
  //     description: data.message
  //   })
  // }
  // if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
  //   notification.error({
  //     message: 'Unauthorized',
  //     description: 'Authorization verification failed'
  //   })
  //   if (token) {
  //     store.dispatch('Logout').then(() => {
  //       setTimeout(() => {
  //         window.location.reload()
  //       }, 1500)
  //     })
  //   }
  // }
  // }
  // return Promise.reject(error)
}

// request interceptor
axios.interceptors.request.use(config => {
  const token = localStorage.token
  const exportArr = ['/api/lesson/data_export', '/api/student/export', '/api/lesson-guidance/export']
  const importArr = [
    '/api/student/import',
    '/api/teacher/import',
    '/api/admin/external_user/import',
    '/api/ai/document/create',
    '/api/ai/document/update'
  ]
  if (config.url.indexOf('//common-api.growlib.com') > -1) {
    config.data = qs.stringify(config.data, { indices: false })
  } else if (!importArr.includes(config.url)) {
    config.data = JSON.stringify(config.data)
  }
  config.headers =
    config.url.indexOf('//common-api.growlib.com') > -1
      ? { 'Content-Type': 'application/x-www-form-urlencoded' }
      : {
          Authorization: 'Bearer' + ' ' + token,
          'Content-Type': importArr.includes(config.url) ? 'multipart/form-data' : 'application/json'
        }
  if (exportArr.indexOf(config.url) > -1) config.responseType = 'blob'
  return config
}, errorHandler)
function tipsMsg(data) {
  message.destroy()
  message.error(`${data.msg}`)
  if (process.env.NODE_ENV === 'development') {
    notification.error({
      message: 'Forbidden',
      description: `msg:${data.msg} code:${data.code}`
    })
  }
}

export const request = async (data, back) => {
  return new Promise((resolve, reject) => {
    const config = {
      // API 请求的默认前缀
      // baseURL: process.env.VUE_APP_API_BASE_URL,
      withCredentials: true,
      onUploadProgress: function(progressEvent) {
        // axios.defaults.onUploadProgress = progressEvent => {
        // 对原生进度事件的处理
        // const complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
        back && back(progressEvent)
      },
      ...data
      // timeout: 6000 // 请求超时时间
    }
    if (config.hostName == 'commonUpload') {
      config.baseURL = 'http://common-api.growlib.com'
    }
    const pams = axios(config)
    if (pams) {
      resolve(pams)
    } else {
      reject(pams)
    }
  }).catch(err => {
    const { status } = err.response
    Modal.error({ title: `服务器出现了问题，请稍后再试，code：${status}！！！` })
  })
}

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request)
  }
}
// export default request
export { installer as VueAxios, request as axios }
